import React from 'react';

const Header = () => {
  return (
    <header className="bg-black text-white py-4 px-6">
      <div className="max-w-7xl mx-auto text-right">
        
      </div>
    </header>
  );
};

export default Header;
